import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C12.6312 4 13.1429 4.51167 13.1429 5.14286V10.8571H18.8571C19.4883 10.8571 20 11.3688 20 12C20 12.6312 19.4883 13.1429 18.8571 13.1429H13.1429V18.8571C13.1429 19.4883 12.6312 20 12 20C11.3688 20 10.8571 19.4883 10.8571 18.8571V13.1429H5.14286C4.51167 13.1429 4 12.6312 4 12C4 11.3688 4.51167 10.8571 5.14286 10.8571H10.8571V5.14286C10.8571 4.51167 11.3688 4 12 4Z"
    />
  </svg>
);

const PlusIcon = (props) => <Icon component={SVG} {...props} />;

export default PlusIcon;
